import { useState } from "react";
import Fade from 'react-reveal';
import ReactPlayer from 'react-player'


export default function Projects(props){

    // https://lottiefiles.com/124016-coding-time
    // https://lottiefiles.com/115670-website-designer

    
    const [tabSelected, setTabSelected] = useState('Portfolio')
    const [projectTitleSelected, setProjectTitleSelected] = useState('Foru AI')

    const LandingText = () => (
        <div className="sm:mt-16 md:pr-10 pr-10 pl-10">
        <h2 className="text-4xl py-1 sm:text-6xl lg:text-6xl font-semibold bg-gradient-to-r from-blue-900 to-teal-600 bg-clip-text text-transparent inline-block transition-all duration-500">My {tabSelected}</h2>
                {/* <div className="border border-gray-400 rounded-md inline-block py-2 px-5 mt-5 sm:mt-16 ">
                    Modal Searchbox
                </div>
                <div className="text-lg font-extralight my-4">Flutter package for selecting one unique value or multiple values from a set of values. This package can be used as an alternative to Flutter DropdownButton</div> */}
            <div className="tab-bg mt-10">
                <Tabs tabName="Portfolio" />
                <Tabs tabName="Product" />
                <Tabs tabName="Library" isEnd={true} />
            </div>
            <div className="p-4 border w-full lg:h-85 h-[95] border-slate-200 border-solid rounded-tr-xl">
                <TabContent />
            </div>
        </div>
    )


    const Tabs = (props) => {
        return (
            <>
            <div style={{backgroundColor: (tabSelected !== props.tabName) ? 'rgba(241, 245, 249, .5)' : 'white', color: (tabSelected === props.tabName) ? 'rgb(71 85 105)' : 'rgb(100 116 139)',
        borderTopRightRadius: (props.isEnd) ? 10 : 0, borderRightWidth: (props.isEnd) ? 1 : 0    
        }} className="text-slate-500 font-semibold hover:cursor-pointer py-3 px-3 sm:px-5 bg-slate-50 border-slate-200 border border-spacing-3 border-b-0 inline-block" onClick={(s) => {
                setTabSelected(props.tabName);
                //set default option
                if(props.tabName === "Portfolio"){
                    setProjectTitleSelected("Foru AI");
                }else if(props.tabName === "Product"){
                    setProjectTitleSelected("Kamus Inggris Lengkap");
                }else if(props.tabName === "Library"){
                    setProjectTitleSelected("Modal Search Box");
                }
            }} >{props.tabName}</div>
            </>
        )
    }

    const ProductOption = (args) => {
        var isSelected = projectTitleSelected === args.title;
        return <div onClick={ () => { 
            if(args.title === "More ..."){
                window.open('https://play.google.com/store/apps/dev?id=8152103288885796153', '_blank', 'noreferrer');
            }else{
                setProjectTitleSelected(args.title); 
            }
        
        } } 
        className="hover:cursor-pointer hover:bg-slate-200 border border-gray-300 rounded-md inline-block py-2 px-5 mr-2 mt-2" 
        style={{backgroundColor: (isSelected) ? 'rgba(251, 146, 60, 1)' : 'white', color: (isSelected) ? 'white' : 'rgb(71, 85, 105)', borderWidth: (isSelected) ? '0px': '1px'}}
        >
        {args.title}
        </div>
    }

    const TabContent = () => {
        if(tabSelected === "Portfolio"){
            return (<>
            <ProductOption title="Foru AI" />
            <ProductOption title="Untukmu AI" />
            <ProductOption title="Financial App" />
            <ProductOption title="iKontraktor" />
            <ProductOption title="Sutera Emas" />
            <ProductOption title="E-Sakip" />
            <ProductOption title="Coal Mine" />
            <ProductOption title="Klinik Hutan" />
            <ProductOption title="GO Sigap" />
            <div className="text-sm lg:text-md font-extralight my-4"><ProjectDescription /></div>
            </>)
        }else if(tabSelected === "Product"){
            return (<>
                <ProductOption title="Kamus Inggris Lengkap" />
                <ProductOption title="Kuis Cerdas Cermat" />
                <ProductOption title="Kuis Tebak Tebakan" />
                <ProductOption title="Drug Dictionary" />
                <ProductOption title="Resep Obat Tradisional" />
                <ProductOption title="More ..." />
            <div className="text-sm lg:text-md font-extralight my-4"><ProjectDescription /></div>
                
            </>)
        }else{
            return (<>
            <ProductOption title="Modal Search Box" />
            <div className="text-sm lg:text-md font-extralight my-4"><ProjectDescription /></div>
            </>)
        }
    }

    const ProjectDescription = () => {
        if(projectTitleSelected === "Modal Search Box"){
            return (<p>
            "Modal Searchbox" is a package library for mobile application development using Flutter. This package is used to display a list of options in the form of a bottom sheet that comes with a search feature and multiple selection option. This is very useful when there are many options available and makes it easier for users to choose the desired option. This package is an alternative to the dropdown when there are a lot of data options. You can get this package in <a href="https://pub.dev/packages/modal_searchbox" className="text-blue-500">Pub.Dev</a>
            </p>)
        }else if(projectTitleSelected === "Untukmu AI"){
            return (<>
            <p>Untukmu.ai Gifting is a gift-giving application supported by AI that makes gifting easy and memorable. Schedule reminders, suggest gifts, and send them easily without hassle. Perfect for both personal and corporate gift-givers. Untukmu AI also available on iOS and Android, visit our official Untukmu website on
            <a href="https://www.untukmu.ai" className="text-blue-700 ml-1">Untukmu AI</a> 
            <br/><br/>
            Stack: Flutter, Getx State Management, Firebase (cloud messaging, analytics, crashlytics, auth, storage, remote config, dynamic link), Google (sign in, map), Apple sign in, Flutter Flavor, SSL Pinning, Get Connect.
            </p>
            </>)
        }else if(projectTitleSelected === "Foru AI"){
            return (<>
            <p>ForU AI is a mobile application that combines artificial intelligence, decentralized identity (DID), and blockchain technology to help users own, manage, and monetize their digital identity and reputation. Through the app, users can build a verifiable AI-powered digital identity, earn reputation badges and rewards based on real contributions, control and monetize their personal data, and participate in the ForU ecosystem powered by the $FORU token.
            <a href="https://www.foruai.io" className="text-blue-700 ml-1">ForU AI</a> 
            <br/><br/>
            Stack: Flutter, Getx State Management, Firebase (cloud messaging, analytics, crashlytics, auth, storage, remote config, dynamic link), Google (sign in), Flutter Flavor, SSL Pinning, Get Connect.
            </p>
            </>)
        }else if(projectTitleSelected === "Financial App"){
            return (<>
            <p>Crypto investment application that allows users to purchase different crypto investment products with varying capital value, minimum top-up, and locking periods. Each product has a different investment profile, such as risk level, potential return, and investment duration.</p>
            <br/>
            Stack: Flutter, Riverpod State Management, Flutter Hook, GraphQL, Firebase (auth, cloud messaging, analytics, crashlytics), FL Chart, Flutter Flavor, SSL Pinning, Http.
            </>)
        }else if(projectTitleSelected === "iKontraktor"){
            return (<>
            <p>iKontraktor is an all-in-one application designed to streamline the management of construction projects, from planning and development to completion. With iKontraktor, contractors can easily track the progress of their projects, including buildings, apartments, houses and more. The application also provides a range of tools to help manage resources and personnel, including the ability to track employee and resource usage and monitor budget expenditures. iKontraktor is the ideal solution for contractors looking to improve efficiency and reduce costs.</p>
            <br/>
            Stack: Flutter, Getx State Management, Flutter Hook, Flutter Flavor, Dio.
            </>)
        }else if(projectTitleSelected === "Sutera Emas"){
            return (<>
            <p>Sutera Emas, or Surveilans Epidemiologi Terpadu Berbasis Masyarakat (Surveillance Epidemiology Integrated Based on Community), is an internal application developed for the Health Department of Malang district. The purpose of this application is to survey and monitor the incidence of diseases and Public Health Emergency of International Concern (PHEIC) in the area. The application enables the health department to track the cases and provide real-time data analysis, allowing for prompt and effective response to public health emergencies.</p>
            <br/>
            Stack: Android Native (Kotlin), MVVM, Google Map, Geocoding, Chart, PDF View.
            </>)
        }else if(projectTitleSelected === "GO Sigap"){
            return (<>
            <p>Go Sigap is a panic button application used by the Gresik Police Station to enhance the sense of security and comfort for the community. This application is integrated with multiple institutions and can be used both online and offline. The main feature of this application is the panic button, which allows users to immediately contact the Gresik Police Station in emergency situations. In addition, the application also provides a feature for registering SIM & SKCK applications, as well as information about earthquakes and news updates from the Gresik Police Station.</p>
            <br/>
            Stack: Android Native (Java), MVC, Http, Google Map, Open Signal Push notification, Jitsi Video Call 
            </>)
        }else if(projectTitleSelected === "E-Sakip"){
            return (<>
            <p>E-Sakip is an application developed for Dinas Perumahan, Kawasan Permukiman dan Cipta Karya (Housing, Residential Areas and Creative Works Agency of Malang district) to aid in managing and monitoring the agency's performance. The app allows users to track individual performance based on their position, view performance reports and evaluate results achieved by employees. It also enables users to view reports based on field, secretariat and UPT, allowing the agency to evaluate their overall performance and take necessary actions to improve it.</p>
            <br/>
            Stack: Cubit State Management, PDF View, Dio.
            </>)
        }else if(projectTitleSelected === "Klinik Hutan"){
            return (<>
            <p>Klinik Hutan is an application designed to assist in monitoring and maintaining the condition of forests. The app provides a feature for creating discussion threads about the status of forest conditions, allowing users to share information and discuss issues in the forest. Additionally, users can upload photos, documents, and specify the location of the forest being reported. </p>
            <br/>
            Stack: Android Native (Java), MVC, Http, Document Reader, Google Push Notification
            </>)
        } else if(projectTitleSelected === "Coal Mine"){
            return (<>
            <p>Coal Mine is a mining management application that allows users to update production and haulage status, track shipments, and monitor customer balance. The application has a feature that allows the user to generate shipment reports based on a specific period. The application also has a feature for void approval, to ensure that any errors or inaccuracies in the shipment can be corrected before it is finalized. This makes it easy for users to efficiently manage their mining operations and make informed decisions by providing accurate and up-to-date data. This application is suitable for mining companies looking to increase operational efficiency and improve profitability.
            <br/><br/>
            Stack: Flutter, Getx State Management, PDF View, Http.
            </p>
            </>)
        } else if(projectTitleSelected === "Kamus Inggris Lengkap"){
            return (<>
            <p>"Advance English Dictionary" or Kamis Inggris Lengkap is an app for translating English-Indonesian offline and online. Features include text, photo, and audio translations; advanced grammar checks; and comprehensive learning materials for all levels. Practice TOEFL with thousands of questions and daily progress charts. Access profession-specific sentence examples and fun features like animal language translators. You can download this app on <a href="https://play.google.com/store/apps/details?id=com.paperplay.kamusinggrisindonesia" className="text-blue-500"> Google Play </a>
            </p>
            <br/> 
            Stack: Flutter, Getx State Management, Firebase (analytics, crashlytics, auth, storage, remote config, dynamic link), Google (sign in).
            </>)
        }  else if(projectTitleSelected === "Kuis Cerdas Cermat"){
            return (<>
            <p>"Kuis Cerdas Cermat" is an application that features hundreds of quiz questions based on categories such as mathematics, science, social studies, language, technology, etc. Each category has 5 levels and each level consists of 20 questions. This application is built using the Unity3D game engine and designed using Adobe Illustrator. The app has also been successful on the Google Play store with over 100,000 downloads. With this quiz application, users will be able to test their knowledge and improve their understanding of various subjects. You can download this app on <a href="https://play.google.com/store/apps/details?id=com.paperplay.kuiscerdascermat" className="text-blue-500"> Google Play </a>
            </p>
            <br/> 
            Stack: Unity3d, Google Play Service, Google Mobile Ads (Admob).
            </>)
        } else if(projectTitleSelected === "Kuis Tebak Tebakan"){
            return (<>
            <p>"Kuis Tebak Tebakan" is an entertaining and fun quiz application that features hundreds of riddles. The app has five levels, with each level consisting of 20 questions. The application is built using the Unity3D game engine and designed using Adobe Illustrator. The app has also been successful on the Google Play store, with over 100,000 downloads. It is a great way to test your knowledge and have fun while guessing the answers, the game is suitable for all ages. This application is perfect for killing time, sharpening your mind and having fun with friends and family. You can download this app on <a href="https://play.google.com/store/apps/details?id=com.paperplay.kuistebaktebakan" className="text-blue-500"> Google Play </a>
            <br/> 
            Stack: Unity3d, Google Play Service, Google Mobile Ads (Admob).
            </p>
            </>)
        } else if(projectTitleSelected === "Drug Dictionary"){
            return (<>
            <p>"Drug Dictionary" is an application that serves as a comprehensive collection of medicine information. It includes descriptions, indications, brands, dosages, prices, categories, synonyms, drug interactions, food interactions, toxicity, affected organisms, metabolism and absorption for each medication. It is a useful tool for healthcare professionals and students, as well as anyone interested in learning more about the medications they are taking or prescribing. With this application, users can easily access up-to-date and accurate information about various drugs, which helps them to make informed decisions and provide better care for their patients. You can download this app on <a href="https://play.google.com/store/apps/details?id=com.paperplay.drugdictionary" className="text-blue-500"> Google Play </a>
            <br/>
            Stack: Android Java Native, SQLite, Google Mobile Ads (Admob).
            </p>
            </>)
        }  else if(projectTitleSelected === "Resep Obat Tradisional"){
            return (<>
            <p>"Resep Obat Tradisional (Traditional Medicine Recipe) is an application that provides a collection of traditional medicine recipes to treat various common illnesses such as allergies, coughs, and more. The application will display complete recipes, including the required ingredients, the method of preparation, and the daily recommended consumption guidelines. This application is very useful for those who want to try alternative treatments and find solutions for simple health problems. Traditional Medicine Recipe provides easily accessible and followable information. You can download this app on <a href="https://play.google.com/store/apps/details?id=com.paperplay.resepobattradisional" className="text-blue-500"> Google Play </a>
            <br/> 
            Stack: Android Java Native, SQLite, Google Mobile Ads (Admob).
            </p>
            </>)
        } 
    }

    const ProjectImage = () => {
        var imgName = "cfund_600.gif";

        if (projectTitleSelected === "Modal Search Box"){
            imgName = "modal-searchbox.gif";
        } else if (projectTitleSelected === "Foru AI") {
            imgName = "foruai.gif";
        } else if (projectTitleSelected === "Untukmu AI") {
            imgName = "untukmu.gif";
        } else if (projectTitleSelected === "CFund App") {
            imgName = "cfund_600.gif";
        }  else if (projectTitleSelected === "iKontraktor") {
            imgName = "ikontraktor.gif";
        } else if (projectTitleSelected === "Sutera Emas") {
            imgName = "sumas.gif";
        } else if (projectTitleSelected === "E-Sakip") {
            imgName = "sakip.gif";
        } else if (projectTitleSelected === "Coal Mine") {
            imgName = "tambang.gif";
        } else if (projectTitleSelected === "Klinik Hutan") {
            imgName = "klinikhutan.gif";
        }  else if (projectTitleSelected === "Kamus Inggris Lengkap") {
            imgName = "kamus_inggris.gif";
        } else if (projectTitleSelected === "Kuis Cerdas Cermat") {
            imgName = "cerdascermat.gif";
        } else if (projectTitleSelected === "Kuis Tebak Tebakan") {
            imgName = "tebaktebakan.gif";
        } else if (projectTitleSelected === "Drug Dictionary") {
            imgName = "drugdictionary.gif";
        } else if (projectTitleSelected === "Resep Obat Tradisional") {
            imgName = "resepobat.gif";
        } else if (projectTitleSelected === "GO Sigap") {
            return (
                <div className="h-[500px] w-full md:mt-16 flex">
                <div className="m-10 w-full relative" style={{paddingTop: '56%'}}>
                          {/* <div className='player-wrapper'> */}
                    <ReactPlayer url='https://www.youtube.com/watch?v=bfho3qIbae4' 
  aspectRatio="16:9" width='100%' height='100%' className='absolute top-0 left-0' />
  {/* </div> */}
                </div>
                </div>
            )
        }

        return <img src={"./assets/demo/"+imgName} className="h-[500px] mx-auto my-12 float-right" alt={`${projectTitleSelected} screenshot`} />;
    }


    return (<>
        <section className="grid py-20 sm:grid-cols-2 w-full  " id="portfolio" ref={props.refs} aria-label="Portfolio">
            <Fade left>
                <LandingText />
            </Fade>
            <Fade right>
                <div  className="md:p-5 h-full flex">
                    <ProjectImage />
                </div>
            </Fade>
        </section>
        <hr />
    </>)
}